<template>
  <div
    :id="`landing-${appName}`"
    class="landing-page"
    :class="{ 'rtl': locale === 'ar' }">
    <slot name="before-header"></slot>
    <WelcomeBar @openPromo="$emit('openPromo')" />
    <AppHeader
      :appName="appName"
      :locale="locale"
    >
      <template v-if="$slots['logo-first-line']" #logo-first-line>
        <slot name="logo-first-line"></slot>
      </template>

      <template v-if="$slots['logo-second-line']" #logo-second-line>
        <slot name="logo-second-line"></slot>
      </template>
    </AppHeader>
    <LandingOffer
      id="landOffer"
      :desc="offerDesc"
      :styles="offerStyles"
      :car="appName === 'car'">
      <template v-slot:header>
        <slot name="header"></slot>
      </template>
    </LandingOffer>
    <section class="landing-inner">
      <div class="landingForm">
        <div ref="form" class="landingForm__block" id="landForm">
          <h3 class="landingForm__title">{{ formTitle || $t('qic_landing_get_quote')}}</h3>
          <slot name="form"></slot>
        </div>
      </div>
      <div class="container-left">
        <section class="mobile-bullets">
          <CarOfferBullets v-if="appName === 'car'" mobile/>
          <LandingOfferBullets v-else mobile/>
        </section>
        <LandingTrusted :image="trustedImage"/>
        <slot name="installment"></slot>
        <section class="includesNew">
          <h3 class="title">{{ includesHeader }}</h3>
          <slot name="includes"></slot>
        </section>
        <slot name="content"></slot>
      </div>
    </section>
    <AppFooter
      :appName="appName"
      :locale="locale"
      @generalQuestion="$emit('generalQuestion', $event)"
      @mandatoryQuestion="$emit('mandatoryQuestion', $event)"
    />

    <LandingGetQuoteButton
      ref="quoteButton"
      :class="{'reversed': reversedQuoteButton}"
      @click="$emit('scrollToForm')"
    />
  </div>
</template>

<script>
import AppHeader from './../header/AppHeader.vue'
import LandingOffer from './LandingOffer.vue'
import LandingTrusted from './LandingTrusted.vue'
import AppFooter from './../footer/AppFooter.vue'
import LandingGetQuoteButton from './LandingGetQuoteButton.vue'
import LandingOfferBullets from './LandingOfferBullets.vue'
import CarOfferBullets from './CarOfferBullets.vue'
import WelcomeBar from './../header/banners/WelcomeBar.vue'
export default {
  name: 'BaseLanding',
  emits: [
    'scrollToForm'
  ],
  props: {
    trustedImage: { type: String },
    appName: { type: String },
    offerStyles: { type: String },
    offerDesc: { type: String },
    includesHeader: { type: String },
    formTitle: {},
    reversedQuoteButton: { type: Boolean, default: false }
  },
  components: {
    WelcomeBar,
    AppHeader,
    LandingOffer,
    LandingTrusted,
    AppFooter,
    LandingGetQuoteButton,
    LandingOfferBullets,
    CarOfferBullets
  },
  computed: {
    locale () {
      return this.$i18n.locale
    }
  },
  metaInfo: {
    meta: [
      { name: 'theme-color', content: '#ffffff' },
      { name: 'msapplication-navbutton-color', content: '#ffffff' },
      { name: 'apple-mobile-web-app-status-bar-style', content: '#ffffff' }
    ]
  },
  methods: {
    goToForm () {
      const scrollToElementCoords = this.$refs.form.getBoundingClientRect()
      window.scrollTo({
        left: scrollToElementCoords.left + window.pageXOffset,
        top: scrollToElementCoords.top + window.pageYOffset,
        behavior: 'smooth'
      })
    }
  },
  mounted () {
    const btnLand = document.querySelectorAll('.btnLand')
    window.addEventListener('scroll', function () {
      if (window.scrollY > 900) {
        btnLand.forEach((item) => {
          item.classList.add('opacity')
        })
      } else {
        btnLand.forEach((item) => {
          item.classList.remove('opacity')
        })
      }
    })
    const twoMinutes = document.querySelector('.offerLandings__title-span')
    const mainForm = document.querySelector('.landingForm__block')
    twoMinutes.addEventListener('click', e => {
      mainForm.classList.add('animationForm')
      setTimeout(function () {
        mainForm.classList.remove('animationForm')
      }, 250)
    })
  }
}
</script>

<style lang="scss">
.reversed {
  color: #5927FF !important;
  background: #fff !important;
  svg {
    path {
      fill: #5927FF;
    }
  }
}
</style>
